import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=f694e988"
import script from "./BusinessType.vue?vue&type=script&lang=js"
export * from "./BusinessType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports